<template>
  <el-container class="up-main">
      <el-aside width="211px">
          <left-menu :active="2"></left-menu>
      </el-aside>
      <el-main class="u-main">
        <user-inf :subject="'zssj'"></user-inf>
      </el-main>
  </el-container>
</template>

<script>
import userInf from '../components/userInf'
import leftMenu from './components/leftMenu'
export default {
  name: "cIndex",
  components: {
    leftMenu, userInf
  },
  data() {
    return {
      
    }
  },
  created() {
    
  },
  methods: {
    
  }
}
</script>

<style lang="less">
@import '../style.less';
</style>
